import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { aceAssignmentKeys } from '../../cache-keys/aceAssignmentKeys';

export function useGetAgentAssignmentsListV3(
  agentId: string,
  options?: { enabled?: boolean },
) {
  const api = useAPI();

  return useQuery({
    queryKey: [aceAssignmentKeys.agentAssignments(agentId)],
    queryFn: () =>
      ace_api.getAgentAssignmentsListV3(api)({ AgentID: agentId }),
    enabled:
      agentId !== '' && api.token !== '' && (options?.enabled ?? true),
  });
}
